'use client';
import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { motion } from 'framer-motion';
import { PostContent } from '../../types/blog';

interface RelatedPostsProps {
  currentSlug: string;
  allPosts: PostContent[];
  maxPosts?: number;
}

export default function RelatedPosts({
  currentSlug,
  allPosts,
  maxPosts = 3,
}: RelatedPostsProps) {
  // Фильтруем текущий пост и получаем похожие посты
  const relatedPosts = allPosts
    .filter((post) => post.slug !== currentSlug)
    .slice(0, maxPosts);

  if (relatedPosts.length === 0) {
    return null;
  }

  return (
    <section className="bg-gray-50 rounded-2xl p-8">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">
        Схожі статті
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {relatedPosts.map((post, index) => (
          <motion.article
            key={post.slug}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: index * 0.1 }}
            className="group bg-white rounded-xl shadow-sm overflow-hidden hover:shadow-md transition-shadow"
          >
            <Link href={`/blog/${post.slug}`}>
              <div className="relative h-40 w-full">
                <Image
                  src={post.meta.image}
                  alt={post.meta.title}
                  fill
                  className="object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 bg-primary/10 text-primary rounded-full text-sm font-medium">
                    {post.meta.category}
                  </span>
                </div>
              </div>

              <div className="p-4">
                <h3 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-primary transition-colors line-clamp-2">
                  {post.meta.title}
                </h3>
                <p className="text-gray-600 text-sm line-clamp-2">
                  {post.meta.description}
                </p>
                <div className="mt-4 flex items-center text-sm text-gray-500">
                  <time>{post.meta.date}</time>
                </div>
              </div>
            </Link>
          </motion.article>
        ))}
      </div>
    </section>
  );
} 